import { FormProvider, useForm } from "react-hook-form";
import { AddSectionRow } from "./AddSectionRow";
import { SectionAccordion } from "./SectionAccordion";
import { ConfirmDelete } from "./ConfirmationModal";

interface VisualEditorProps {
    sections: PolicyFormSection[];
    questions: Record<string, PolicyFormQuestion>;
    onSectionChange: (sectionId: string, updates: Partial<PolicyFormSection>) => void;
    onSubsectionChange: (
        sectionId: string,
        subsectionId: string,
        updates: Partial<PolicyFormSubSection>,
    ) => void;
    onQuestionGroupChange: (
        sectionId: string,
        subsectionId: string,
        groupId: string,
        updates: Partial<PolicyFormQuestionGroup>,
    ) => void;
    onQuestionChange: (questionId: string, updates: Partial<PolicyFormQuestion>) => void;
    onAddQuestionToGroup: (
        sectionId: string,
        subsectionId: string,
        groupId: string,
        newQuestion: PolicyFormQuestion
    ) => void;
    onAddGroup: (
        sectionId: string,
        subsectionId: string,
        group: PolicyFormQuestionGroup
    ) => void;
    onAddSubsection: (
        sectionId: string,
        subsection: PolicyFormSubSection
    ) => void;
    onAddSection: (
        section: PolicyFormSection
    ) => void;
    onRemoveQuestion: (
        sectionId: string,
        subsectionId: string,
        groupId: string,
        questionId: string
    ) => void;
    onRemoveGroup: (
        sectionId: string,
        subsectionId: string,
        groupId: string
    ) => void;
    onRemoveSubsection: (
        sectionId: string,
        subsectionId: string
    ) => void;
    onRemoveSection: (
        sectionId: string
    ) => void;
    confirmDelete: {
        open: boolean;
        title?: string;
        message?: string;
        onConfirm?: () => void;
    };
    setConfirmDelete: React.Dispatch<React.SetStateAction<{
        open: boolean;
        title?: string | undefined;
        message?: string | undefined;
        onConfirm?: (() => void) | undefined;
    }>>;
}

export function VisualEditor({
    sections,
    questions,
    onSectionChange,
    onSubsectionChange,
    onQuestionGroupChange,
    onQuestionChange,
    onAddQuestionToGroup,
    onAddGroup,
    onAddSubsection,
    onAddSection,
    onRemoveQuestion,
    onRemoveGroup,
    onRemoveSubsection,
    onRemoveSection,
    confirmDelete,
    setConfirmDelete
}: VisualEditorProps) {

    const methods = useForm({
        defaultValues: { questions },
    });

    return (
        <FormProvider {...methods}>
            <div className="space-y-6">
                {
                    sections.map((section) => (
                        <SectionAccordion
                            key={section.id}
                            section={section}
                            onSectionChange={onSectionChange}
                            onSubsectionChange={onSubsectionChange}
                            onQuestionGroupChange={onQuestionGroupChange}
                            onAddSubsection={onAddSubsection}
                            onAddGroup={onAddGroup}
                            onAddQuestionToGroup={onAddQuestionToGroup}
                            onQuestionChange={onQuestionChange}
                            onRemoveQuestion={onRemoveQuestion}
                            questions={questions}
                            onRemoveGroup={onRemoveGroup}
                            onRemoveSubsection={onRemoveSubsection}
                            onRemoveSection={onRemoveSection}
                        />
                    ))
                }
                <AddSectionRow onAddSection={onAddSection} />
                <ConfirmDelete
                    open={confirmDelete.open}
                    title={confirmDelete.title || ""}
                    message={confirmDelete.message || ""}
                    onConfirm={confirmDelete.onConfirm || (() => { })}
                    onCancel={() => setConfirmDelete({ ...confirmDelete, open: false })}
                />
            </div>
        </FormProvider>
    )
}